import { Box, SxProps, Theme } from "@mui/material";
import Image from "next/image";
import { FONT_UI, SpineToken } from "@/src/components/common/broadsheet/tokens";

export default function CoverPlate({
  src,
  alt,
  width,
  height,
  spine = "var(--bf-spine-teal)",
  offset = 4,
  priority = false,
  fit = "cover",
  framed = false,
  sizes,
  sx,
}: {
  src?: string | null;
  alt: string;
  width: number;
  height: number;
  spine?: SpineToken | string;
  offset?: number;
  priority?: boolean;
  fit?: "cover" | "contain";
  framed?: boolean;
  sizes?: string;
  sx?: SxProps<Theme>;
}) {
  return (
    <Box
      sx={[
        {
          position: "relative",
          flex: "none",
          width,
          height,
          maxWidth: "100%",
          overflow: "hidden",
          background: "var(--bf-cover-plate)",
          boxShadow: `${offset}px ${offset + 1}px 0 0 ${spine}`,
          ...(framed && {
            border: "1px solid",
            borderColor: "custom.ruleHairline",
          }),
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {src ? (
        <Image
          src={src}
          alt={alt}
          fill
          sizes={sizes ?? `${width}px`}
          {...(priority
            ? { preload: true, fetchPriority: "high" as const }
            : { loading: "lazy" as const })}
          style={{ objectFit: fit }}
        />
      ) : (
        <Box
          aria-hidden="true"
          sx={{
            position: "absolute",
            inset: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: FONT_UI,
            fontSize: "0.625rem",
            letterSpacing: "0.08em",
            textTransform: "uppercase",
            color: "var(--bf-cover-plate-text)",
            backgroundImage:
              "repeating-linear-gradient(45deg, rgba(0,0,0,0.045) 0 6px, transparent 6px 12px)",
          }}
        >
          Brieflands
        </Box>
      )}
    </Box>
  );
}
